/** @type {import('@rhino-project/core/config').RhinoConfig} */
const rhinoConfig = {
  version: 1,
  components: {}
};

export default rhinoConfig;
